// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2804d710","977":"7001c567"}[chunkId] + ".chunk.js";
};